import "./paing.moduleRenamed.css";

export const dot = "paing-module__dot___G3IMn";
export const dots = "paing-module__dots___gbvrd";

export default {
  dot: "paing-module__dot___G3IMn",
  dots: "paing-module__dots___gbvrd",
};